import axios from 'axios';

/**
 * Product feedback capture (PD-1289). Backed by the `user_feedback` table —
 * see cUserFeedback.vue, which is the only intended caller.
 */

/**
 * In-flight/settled settings request, shared by every control on the page.
 * The settings are small, change rarely and are the same for everyone, so the
 * whole table is fetched once per page load rather than once per control.
 */
let settingsRequest = null;

function fetchSettings() {
  if (!settingsRequest) {
    settingsRequest = axios
      .get('/UserFeedback/settings')
      .then((resp) => (Array.isArray(resp.data?.Data) ? resp.data.Data : []))
      .catch((err) => {
        // Don't cache a failure — the next control to mount should try again.
        settingsRequest = null;
        throw err;
      });
  }
  return settingsRequest;
}

export const userFeedbackApi = {

  /**
   * Presentation settings for one feature (PD-1289b), or null when the feature
   * has no row — the control then falls back to its prop defaults.
   *
   * @param {String} feedbackType
   * @returns {Promise<Object|null>}
   */
  async getSettings(feedbackType) {
    const rows = await fetchSettings();
    const wanted = (feedbackType || '').toUpperCase();
    return rows.find((r) => (r.feedback_type || '').toUpperCase() === wanted) || null;
  },

  /** Drop the cached settings, so the next read goes back to the API. */
  clearSettingsCache() {
    settingsRequest = null;
  },

  /**
   * @param {Object} payload
   * @param {String} payload.feedback_type              which feature is being rated
   * @param {Number} payload.rating                     0/1 for thumbs, 1..5 for stars
   * @param {String} [payload.comment]
   * @param {Number} [payload.doc_id]
   * @param {Number} [payload.document_lf_evaluation_id]
   * @param {Number} [payload.file_id]
   * @param {Number} [payload.prompt_chain_id]
   */
  addFeedback(payload) {
    return axios.post('/UserFeedback/add', payload);
  }
};

export default userFeedbackApi;
